module.exports = __webpack_public_path__ + "static/media/ope3.png.23f2995a.jpg";